import { GO_TO_NEXT_DATE, GO_TO_PREV_DATE } from "./constants";

export default function currentDateReducer(date = new Date(), action){

  switch(action.type){

    case GO_TO_NEXT_DATE:
      const nextDate = new Date(date);
            nextDate.setDate(nextDate.getDate() + 1);
      return nextDate;

    case GO_TO_PREV_DATE:
      const prevDate = new Date(date);
            prevDate.setDate(prevDate.getDate() - 1);
      return prevDate;
  }

  return date;

}
